/* Project Import will be here */
import { authTokenKey } from "../services/index";
/* Project Import will be here */

export type ILocationMasterParams = {
    data: {
        locId: number,
        levelId: number
    },
    headers: {
        [authTokenKey]: string
    }
};

export type ICountryParams = {
    headers: {
        [authTokenKey]: string
    }
};

/* Pass CountryId as locId */
export type IRegionsParams = {
    locId: string,
    headers: {
        [authTokenKey]: string
    }
};

/* Pass Region as locId  */
export type IStatesParams = {
    locId: string,
    headers: {
        [authTokenKey]: string
    }
};

/* Pass StateId as locId  */
export type ICitiesParams = {
    locId: string,
    headers: {
        [authTokenKey]: string
    }
};

export type IPrinciplesParams = {
    headers: {
        [authTokenKey]: string
    }
};

export type ILocationActionParams = {
    locId: string
};

export type IGeoLocationModel = {
    lat: decimal,
    long: decimal
}

export type IStaticContentParams = {
    Code: string
}